// import { userPriv, userInvalid } from "utils/privilege.util";
import store from "stores";
import { userType, userPrivilege } from "const/nuclias/user";

import { cloneDeep, isNil } from 'lodash';

export const defaultMessages = {
  success: null,
  error: null,
  warning: null,
};

export const defaultPagination = {
  current: 1,
  pageLimit: 10,
  currentLength: 0
};

export const actionsLabel = {
  edit: '7e77616685',
  createSite: 'fa111d766b',
  createTag: 'cd5ff8bec4',
  invite: '440a99b2ea',
  delete: 'f2a6c498fb'
};

export const defaultColumns = (info) => {
  const list = [
    {
      label: info.userType === userType.sp ? 'MSP' : 'c1ca926603',
      accessor: 'name',
      sortable: true,
    },
    {
      label: info.userType === userType.sp ? 'MSP ID' : 'c9772a79fb',
      accessor: 'uid',
      sortable: true,
      hide: info.isOrgUser ? true : false
    },
    {
      label: 'a1fa277792',
      accessor: 'orgTypeLabel',
      sortable: true,
    },
    {
      label: 'a7d6475ec8',
      accessor: 'siteCount',
      sortable: true,
      hide: info.userType === userType.sp ? true : false
    },
    {
      label: '3039a00fca',
      accessor: 'siteTagCount',
      sortable: true,
      hide: info.userType === userType.sp ? true : false
    },
    {
      label: 'c03ca67dda',
      accessor: 'deviceAll',
      sortable: true,
      hide: info.isOrgUser ? false : true
    },
    {
      label: '49757fe172',
      accessor: 'ap',
      sortable: true,
      hide: info.isOrgUser ? false : true
    },
    {
      label: '0052efad5d',
      accessor: 'switch',
      sortable: true,
      hide: info.isOrgUser ? false : true
    },
    {
      label: 'a0ea006dc2',
      accessor: 'gateway',
      sortable: true,
      hide: info.isOrgUser ? false : true
    },
  ];
  const result = (list).filter((item, index) => {
    return isNil(item.hide) || !item.hide;
  });
  return result;
};

export const getDefaultModalStatus = (info) => {
  const { user: { user } } = store.getState();
  const list = {
    org: {
      createLabel: info?.userType === userType.sp ? '2b32b303fd' : '022a09a55b',
      status: false,
      type: 'create'
    },
    tag: {
      status: false,
      type: 'create' // edit
    },
    site: {
      status: false,
      type: 'create' // edit
    },
    invite: {
      status: false,
      disabled: false,
      show: true,
      type: 'MSP' // 'ORG'...
    },
    delete: {
      status: false,
      disabled: false,
    },
    generate: {
      status: false,
    },
    preview: {
      status: false,
      disabled: false
    },
    result: {
      status: false,
      disabled: false
    },
    previewTreeSearch: {
      show: user.type === userType.site ? false : true,
    }
  };

  return list;
};